import { noop } from 'lodash';
import { createContext, useContext } from 'react';
import { CampaignFilters, ParsedMediumMetric, ParsedOverallMetric } from '../types';

type AppliedFilters = {
  mediums?: string[];
  campaignFilters?: CampaignFilters;
  overallMetrics?: ParsedOverallMetric[];
  mediumMetrics?: ParsedMediumMetric[];
  appliedCrossMetrics?: string[];
};

type AppliedFiltersContextState = {
  appliedFilters: AppliedFilters;
  setAppliedFilters: (appliedFilters: AppliedFilters) => void;
};

export const defaultAppliedFiltersState: AppliedFiltersContextState = {
  appliedFilters: {},
  setAppliedFilters: noop,
};

export const AppliedFiltersContext = createContext<AppliedFiltersContextState>(
  defaultAppliedFiltersState,
);

export const useAppliedFiltersContext = () => useContext(AppliedFiltersContext);
